import cn from 'classnames';
import { CSVLink } from 'react-csv';
import { MdOutlineSimCardDownload } from 'react-icons/md';

interface ExportCSVProps {
    fileName?: string;
    className?: string;
    blotter?: any;
    csvData?: any[];
}

const ExportCSV = (props: ExportCSVProps) => {
    const { fileName = 'export.csv', csvData, className } = props;

    return (
        <CSVLink filename={fileName} data={csvData || []}>
            <MdOutlineSimCardDownload className={cn(`w-4 h-4 text-brand-module-title`, className)} />
        </CSVLink>
    );
};

export default ExportCSV;
